import apiClient from "../apiClient";

export const getAllRoutesPublicAPI = async () => {
  try {
    const response = await apiClient.get("rutasMapa/routesPublicAll");
    return response?.data?.data;
  } catch (error) {
    throw error;
  }
};
